module.exports = __webpack_public_path__ + "static/img/rentals3.4b77dbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/rentals3.svg
// module id = jXtG
// module chunks = 1